document.addEventListener('DOMContentLoaded', function() {
    scrollFadein('.js-fadein');
});

function scrollFadein(val) {
    const els = document.querySelectorAll(val);
    const cb = function(entries, observer) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                entry.target.classList.add('is-active');
                observer.unobserve(entry.target); //1回で処理を停止
            } else {
                entry.target.classList.remove('is-active');
            }
        });
    }

    const io = new IntersectionObserver(cb);
    els.forEach(el => io.observe(el));
}

// ハンバーガーメニュー スクロール防止
document.addEventListener('DOMContentLoaded', function() {
    function addActive() {
        document.querySelector('.c-hamburger').classList.toggle('is-active');
        document.querySelector('.c-hamburger__nav').classList.toggle('is-active');
        document.querySelector('body').classList.toggle('fixed');
    }
    document.querySelector('.c-hamburger').addEventListener('click', function() {
        addActive();
    });
});
// ハンバーガーナビクリック時 クローズ
document.querySelectorAll('.c-hamburger__link').forEach(function(hamburger_close){
    hamburger_close.addEventListener('click',function(){
        document.querySelector('.c-hamburger').classList.remove('is-active');
        document.querySelector('.c-hamburger__nav').classList.remove('is-active');
        document.querySelector('body').classList.remove('fixed');
    });
});